import React, { useContext, useState } from "react";
import { NavLink as NavLinkRRD } from "react-router-dom";
import classnames from "classnames";
import { Collapse, Navbar, NavItem, NavLink, Nav } from "reactstrap";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
// import LogoutIcon from "Assets/Icons/LogoutIcon";
// import { useAuth } from "utilFunctions/CustomHooks/useAuth";
import "./sideBar.css";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import { UserInfoContext } from "Context/CommonContext";
import MenuIcon from "Assets/Icons/MenuIcon";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { config } from "config.js";
import SupportHelpIcon from "Assets/Icons/SupportHelpIcon";
export const Sidebar = (props: any) => {
  const { routes, logo, isMiniSideBar, setIsMiniSideBar, setIsNugget } = props;
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const location = useLocation();
  // const { logout } = useAuth();
  const [sidenavOpen, setSidenavOpen] = useState<boolean>(false);
  const { screen }: any = useWindowSize();
  const getSidebarClassName = () => {
    return !isMiniSideBar ? "sidenav-mini" : "sidenav-normal";
  };

  const onMouseEnterSidenav = () => {
    setIsMiniSideBar(true);
    if (document.body.classList.contains("g-sidenav-hidden")) {
      document.body.classList.remove("g-sidenav-hidden");
      document.body.classList.add("g-sidenav-pinned");
      setSidenavOpen(true);
    }
  };

  const onMouseLeaveSidenav = () => {
    setIsMiniSideBar(false);
    if (document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.remove("g-sidenav-pinned");
      document.body.classList.add("g-sidenav-hidden");
      setSidenavOpen(false);
    }
  };
  const activeRoute = (routeName: string) => {
    return location.pathname.indexOf(routeName) > -1 ? true : false;
  };
  const toggleSidenav = () => {
    setSidenavOpen(!sidenavOpen);
  };
  const handleToggle = () => {
    toggleSidenav();
  };
  const route: any = [...routes];
  const handleToggleNugget = (e: any) => {
    e.preventDefault();
    if (["xs", "sm", "md"].includes(screen)) {
      setIsNugget(true);
    }
  };
  const createLinks = (routes: any) => {
    console.log(routes, "before if createLinks=====");
    return routes.map((item: any, key: number) => {
      if (item.redirect) {
        return null;
      } else if (item?.label == "System Health") {
        return (
          <div key={key} className="sidenavNormalDiv">
            {isMiniSideBar ? (
              <>
                {item?.icon}
                {item?.label}
                {item?.icon}
              </>
            ) : (
              <>{item?.icon}</>
            )}
          </div>
        );
      } else {
        return (
          <NavItem active={activeRoute(item.path)} key={key}>
            {sidenavOpen ? (
              <NavLink
                active={activeRoute(item.path)}
                to={item.path}
                className={
                  isMiniSideBar ? "activePathItem" : "activePathItemMiniSidebar"
                }
                onClick={toggleSidenav}
                tag={NavLinkRRD}
              >
                <>
                  {activeRoute(item.path) ? (
                    <div>{item.activeIcon}</div>
                  ) : (
                    <div>{item.icon}</div>
                  )}
                  {isMiniSideBar ? (
                    <div
                      className={
                        activeRoute(item.path)
                          ? "activePathLabel"
                          : "activePathLabelInactive"
                      }
                    >
                      {item.label}
                    </div>
                  ) : null}
                </>
              </NavLink>
            ) : (
              <NavLink
                active={activeRoute(item.path)}
                to={item.path}
                className={
                  isMiniSideBar ? "activePathItem" : "activePathItemMiniSidebar"
                }
                onClick={() => {
                  if (["xs", "sm", "md"].includes(screen)) {
                    setIsMiniSideBar(false);
                    onMouseLeaveSidenav();
                  }
                }}
                tag={NavLinkRRD}
              >
                <>
                  {activeRoute(item.path) ? (
                    <div>{item.activeIcon}</div>
                  ) : (
                    <div>{item.icon}</div>
                  )}
                  {isMiniSideBar ? (
                    <div
                      className={
                        activeRoute(item.path)
                          ? "activePathLabel"
                          : "activePathLabelInactive"
                      }
                    >
                      {item.label}
                    </div>
                  ) : null}
                </>
              </NavLink>
            )}
          </NavItem>
        );
      }
    });
  };
  const returnRoutes = (route: any) => {
    let newRoute: any = route;
    if (userInfo?.fexRole) {
      newRoute = route?.filter((ele: any) =>
        ele.access.includes(userInfo?.fexRole)
      );
    }
    console.log("returnRoutes", newRoute);
    return newRoute;
  };
  const scrollBarInner = (
    <div className="scrollbar-inner">
      <div className="sidenav-header d-flex align-items-center">
        <div className="d-flex justify-content-between align-item-center w-100">
          {isMiniSideBar && (
            <div className="pt-2 pl-3">
              <img
                alt={logo.imgAlt}
                src={config.aakashLogo}
                width={"70px"}
                height={"50px"}
              />
            </div>
          )}
          <div
            className={classnames(
              "d-flex justify-content-center align-items-center",
              {
                active: sidenavOpen,
              }
            )}
            onClick={handleToggle}
          >
            {isMiniSideBar ? (
              <MenuIcon
                className="mr-4"
                onClick={() => {
                  if (["xs", "sm", "md"].includes(screen)) {
                    setIsMiniSideBar(false);
                    onMouseLeaveSidenav();
                  }
                  toggleSidenav();
                }}
              ></MenuIcon>
            ) : (
              <>
                <MenuIcon
                  onClick={() => {
                    setIsMiniSideBar(true);
                    onMouseEnterSidenav();
                    toggleSidenav();
                  }}
                  className="ml-4"
                ></MenuIcon>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="navbar-inner mb-5">
        <Collapse navbar isOpen={true}>
          <Nav navbar>
            {createLinks(returnRoutes(route))}
            {["xs", "sm", "md"].includes(screen) && (
              <NavItem active={false}>
                <NavLink
                  active={false}
                  onClick={handleToggleNugget}
                  className="activePathItemMiniSidebar"
                  // tag={NavLinkRRD}
                >
                  <>
                    <SupportHelpIcon />
                    &nbsp;&nbsp;{" "}
                    <div className={"activePathLabelInactive"}>
                      Help & Support
                    </div>
                  </>
                </NavLink>
              </NavItem>
            )}
          </Nav>
          <hr className="my-3" />
        </Collapse>
      </div>
    </div>
  );

  return (
    <Navbar
      className={`sidenav navbar-vertical navbar-expand-xs navbar-light bg-white fixed-left navbar ${getSidebarClassName()} SIDEMINIBAR`}
      onMouseEnter={onMouseEnterSidenav}
      onMouseLeave={onMouseLeaveSidenav}
      style={{
        scrollbarWidth: "none",
        overflowX: "hidden",
      }}
    >
      {scrollBarInner}
    </Navbar>
  );
};

Sidebar.defaultProps = {
  routes: [{}],
  sidenavOpen: false,
  rtlActive: false,
};

Sidebar.propTypes = {
  // function used to make sidenav mini or normal
  toggleSidenav: PropTypes.func,
  // prop to know if the sidenav is mini or normal
  sidenavOpen: PropTypes.bool,
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  // logo
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as a simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired,
  }),
  // rtl active, this will make the sidebar stay on the right side
  rtlActive: PropTypes.bool,
  setIsMiniSideBar: PropTypes.func,
  isMiniSideBar: PropTypes.bool,
  setIsNugget: PropTypes.func,
};
